import { render, staticRenderFns } from "./DiseaseDocument.vue?vue&type=template&id=0d5df33c&scoped=true"
import script from "./DiseaseDocument.vue?vue&type=script&lang=js"
export * from "./DiseaseDocument.vue?vue&type=script&lang=js"
import style0 from "./DiseaseDocument.vue?vue&type=style&index=0&id=0d5df33c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5df33c",
  null
  
)

export default component.exports